import providerLogos from './providerLogos/index';

export function getLogoFromProvider(provider) {
    if (providerLogos[provider]) {
        return providerLogos[provider];
    } else {
        return providerLogos.fallback;
    }
}
